<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear absolute color="success" height="4" indeterminate></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="deep-gl" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ $t("FIELD_TAGS.VIEW_TAG") }}</v-toolbar-title>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <div class="preview-list">
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.ID") }}:</span>
                  <span class="preview-value">{{ requestData.id || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.NAME") }}:</span>
                  <span class="preview-value">{{ requestData.value || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("FIELD_TAGS.PARENT") }}:</span>
                  <span class="preview-value">{{ requestData.parent_name || "-" }}</span>
                </div>
                <div class="preview-row preview-row--stacked">
                  <span class="preview-label">{{ $t("FIELD_TAGS.CHILDREN") }}:</span>
                  <span class="preview-value">{{ childrenLabel }}</span>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="hasPermissions('field-tags-edit')"
                color="primary"
                class="mr-2"
                :to="{
                  name: 'field-tags-edit',
                  params: {
                    fieldTagTypeId: $route.params.fieldTagTypeId,
                    tagId: requestData.id || $route.params.tagId,
                  },
                }"
              >
                {{ $t("GENERAL.LABELS.EDIT_BUTTON") }}
              </v-btn>
              <v-btn
                v-if="canDelete"
                color="error"
                class="mr-2"
                @click="deleteConfirm = true"
              >
                {{ $t("GENERAL.LABELS.DELETE") }}
              </v-btn>
              <v-btn color="warning" @click="back">{{ $t("GENERAL.LABELS.BACK_BUTTON") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <Confirm
      v-model="deleteConfirm"
      :content="$t('GENERAL.DELETE_CONFIRM')"
      @confirm="deleteFieldTag"
      @decline="deleteConfirm = false"
    />
  </div>
</template>

<script>
import { GET_FIELD_TAG, DELETE_FIELD_TAG } from "@/store/fieldTags.module";
import { SHOW_SNACK } from "@/store/snack.module";
import Confirm from "@/views/partials/dialogs/Confirm.vue";

export default {
  name: "ViewFieldTag",
  components: {
    Confirm,
  },
  data() {
    return {
      tab: "tab-1",
      isProcessing: false,
      deleteConfirm: false,
      requestData: {},
    };
  },
  computed: {
    canDelete() {
      return this.hasPermissions("field-tags-delete") && this.requestData.id;
    },
    childrenLabel() {
      const children = this.requestData.children;
      if (Array.isArray(children) && children.length) {
        return children.map((child) => child.value).filter(Boolean).join(", ");
      }

      if (this.requestData.children_count) {
        return String(this.requestData.children_count);
      }

      return "-";
    },
  },
  mounted() {
    this.loadItem();
  },
  methods: {
    back() {
      this.$router.push({
        name: "field-tags",
        params: { fieldTagTypeId: this.$route.params.fieldTagTypeId },
      });
    },
    loadItem() {
      this.isProcessing = true;
      this.$store
        .dispatch(GET_FIELD_TAG, this.$route.params.tagId)
        .then((response) => {
          this.requestData = response || {};
        })
        .catch(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.UNEXPECTED_ERROR"),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];

        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }

      if (error && error.message) {
        return error.message;
      }

      return this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    deleteFieldTag() {
      this.isProcessing = true;
      this.$store
        .dispatch(DELETE_FIELD_TAG, this.requestData.id || this.$route.params.tagId)
        .then(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.SUCCESS_MESSAGE"),
          });
          this.back();
        })
        .catch((error) => {
          this.$store.dispatch(SHOW_SNACK, {
            type: "error",
            message: this.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.isProcessing = false;
          this.deleteConfirm = false;
        });
    },
  },
};
</script>

<style scoped>
.preview-row--stacked {
  align-items: flex-start;
}
</style>
